import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="show"
      class="notification"
      [ngClass]="{
        success: type === 'success',
        error: type === 'error',
        warning: type === 'warning'
      }"
    >
      <div class="notification-content">
        <i
          class="bi"
          [ngClass]="{
            'bi-check-circle': type === 'success',
            'bi-x-circle': type === 'error',
            'bi-exclamation-circle': type === 'warning'
          }"
        ></i>
        <div class="notification-text">
          <h4>{{ title }}</h4>
          <p>{{ message }}</p>
        </div>
      </div>
      <button class="close-button" (click)="onClose()">
        <i class="bi bi-x"></i>
      </button>
    </div>
  `,
  styles: [
    `
      .notification {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 1rem;
        border-radius: 8px;
        min-width: 300px;
        max-width: 400px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        animation: slideIn 0.3s ease-out;
        z-index: 9999999999999;
      }

      .success {
        background-color: #d4edda;
        border: 1px solid #c3e6cb;
        color: #155724;
      }

      .error {
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
        color: #721c24;
      }

      .warning {
        background-color: #fff3cd;
        border: 1px solid #ffeeba;
        color: #856404;
      }

      .notification-content {
        display: flex;
        gap: 0.75rem;
        align-items: flex-start;
      }

      .notification-text h4 {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
      }

      .notification-text p {
        margin: 0.25rem 0 0 0;
        font-size: 0.9rem;
      }

      .close-button {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: inherit;
        opacity: 0.7;
      }

      .close-button:hover {
        opacity: 1;
      }

      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `,
  ],
})
export class NotificationComponent {
  @Input() show: boolean = false;
  @Input() type: 'success' | 'error' | 'warning' = 'success';
  @Input() title: string = '';
  @Input() message: string = '';

  onClose() {
    this.show = false;
  }
}
